export const log = ({
  level = "info",
  message = "Trigger",
  context = "Unknown",
  data = null,
  enabled = false,
} = {}) => {
  if (!enabled) return;

  const timestamp = new Date().toISOString();

  // Log human-readable string first with context emphasized
  console.log(`[${timestamp}] [${level.toUpperCase()}] Context: ${context} | Message: ${message}`);

  // Include full JSON for structured logging if data exists
  if (data !== null) {
    console.log(JSON.stringify({ timestamp, level, context, message, data }, null, 2));
  }
};